import { Component, Vue } from 'vue-property-decorator'
  import {} from '@/components/base';
  
@Component({
  components: {}
})
export default class Footer extends Vue {

}
  